import { makeVar } from '@apollo/client';
import { Conversation } from 'graphql/main/queries';

export const showingChatBoxVar = makeVar<boolean>(false);
export const selectedConversationVar = makeVar<Conversation | undefined>(undefined);
export const conversationsVar = makeVar<Conversation[] | undefined>(undefined);
//
